// src/components/Sidebar.js
import React from "react";
import styled from "styled-components";
import { 
  FaGlobe, 
  FaCheck, 
  FaTimes, 
  FaQuestion,
  FaCoins
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const SidebarContainer = styled.aside`
  width: 220px;
  min-height: calc(100vh - 60px);
  background: #0F0F0F;
  border-right: 1px solid #00FF41;
  display: flex;
  flex-direction: column;
  padding: 1rem;
`;

const SidebarTitle = styled.h3`
  margin-bottom: 1rem;
  color: #00FF41;
`;

const FilterOption = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  cursor: pointer;

  span {
    margin-left: 0.5rem;
  }

  &:hover {
    color: #0AFF50;
  }

  /* Highlight the currently active filter */
  color: ${({ active }) => (active ? "#0AFF50" : "inherit")};
`;

const Sidebar = ({ currentFilter, setFilter }) => {
  const navigate = useNavigate();

  const handleFilterClick = (filterValue) => {
    setFilter(filterValue);
    navigate("/"); // Go to main feed
  };

  const handleTokenClick = () => {
    navigate("/truth-ai-token");
  };

  return (
    <SidebarContainer>
      <SidebarTitle>Filters</SidebarTitle>

      <FilterOption
        onClick={() => handleFilterClick("All")}
        active={currentFilter === "All"}
      >
        <FaGlobe />
        <span>All News</span>
      </FilterOption>

      <FilterOption
        onClick={() => handleFilterClick("True")}
        active={currentFilter === "True"}
      >
        <FaCheck />
        <span>True Only</span>
      </FilterOption>

      <FilterOption
        onClick={() => handleFilterClick("False")}
        active={currentFilter === "False"}
      >
        <FaTimes />
        <span>False Only</span>
      </FilterOption>

      <FilterOption
        onClick={() => handleFilterClick("Partially True")}
        active={currentFilter === "Partially True"}
      >
        <FaQuestion />
        <span>Partially True</span>
      </FilterOption>

      {/* Single button for $TruthAI (goes to token page) */}
      <FilterOption onClick={handleTokenClick}>
        <FaCoins />
        <span>$TruthAI</span>
      </FilterOption>
    </SidebarContainer>
  );
};

export default Sidebar;
